const init = () => {
  function viewportSet() {
    const windowWidth = window.screen.width;
    if (768 <= windowWidth && windowWidth <= 820) {
      document.querySelector("meta[name='viewport']").setAttribute("content", "width=1200");
    }
  }

  window.addEventListener("DOMContentLoaded", viewportSet);
  // window.addEventListener("resize", viewportSet, false);
  window.addEventListener("orientationchange", viewportSet);
};

export default init;
